/* Miral Lander: globales Produkt (window.MI) + Hero-Buy-Box + Header + Akkordeons.
   Sections sind eigenständig (Editor), hängen aber am selben Produkt-Zustand:
   - jedes Element mit data-mi-for="<handle>" wird ein-/ausgeblendet
   - jeder Button/Link mit data-mi-pick-product="<handle>" setzt das Produkt
   - Event "mi:product" auf window, Detail { handle }
   Preise ausschließlich aus den Varianten (JSON in der Hero-Section). */
(function () {
  'use strict';
  if (window.MI && window.MI.__init) return;

  var MI = window.MI = { product: null, __init: true };

  function all(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function fmt(cents) { return (cents / 100).toFixed(2).replace('.', ',') + ' €'; }
  function packCount(label) { var m = /^(\d+)/.exec(label || ''); return m ? parseInt(m[1], 10) : 1; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function uniq(list) { var seen = {}, out = []; list.forEach(function (x) { if (!seen[x]) { seen[x] = 1; out.push(x); } }); return out; }

  var FLAVOUR_DOTS = { 'Salty Cherry': '#D11F5C', 'Lemon': '#F6D935', 'Mango Passionfruit': '#FDB913' };

  /* ---------- globales Produkt ---------- */
  MI.handles = function () { return uniq(all('[data-mi-for]').map(function (e) { return e.getAttribute('data-mi-for'); })); };

  MI.apply = function () {
    var h = MI.product;
    all('[data-mi-for]').forEach(function (e) { e.hidden = e.getAttribute('data-mi-for') !== h; });
    all('[data-mi-pick-product]').forEach(function (b) {
      if (!b.classList.contains('mi-pill')) return;
      if (b.getAttribute('data-mi-pick-product') === h) b.setAttribute('data-on', ''); else b.removeAttribute('data-on');
    });
    window.dispatchEvent(new CustomEvent('mi:product', { detail: { handle: h } }));
  };

  MI.set = function (handle) {
    if (!handle || handle === MI.product) { MI.apply(); return; }
    MI.product = handle;
    MI.apply();
  };

  MI.initProduct = function () {
    var hs = MI.handles();
    if (!hs.length) return;
    var fromUrl = null;
    try { fromUrl = new URLSearchParams(window.location.search).get('p'); } catch (e) { /* alt */ }
    if (!MI.product || hs.indexOf(MI.product) < 0) MI.product = (fromUrl && hs.indexOf(fromUrl) >= 0) ? fromUrl : hs[0];
    MI.apply();
  };

  /* ---------- Hero / Buy Box ---------- */
  function Hero(root) {
    if (root.__mi) return root.__mi;
    var self = root.__mi = { root: root };
    var dataEl = root.querySelector('[data-mi-products]');
    try { self.products = JSON.parse(dataEl.textContent); } catch (e) { console.error('mi-hero: Produktdaten unlesbar', e); self.products = []; }
    self.ctaLabel = root.getAttribute('data-cta-label') || 'In den Warenkorb';
    self.priceNote = root.getAttribute('data-price-note') || '';
    self.defaultFlavour = root.getAttribute('data-default-flavour') || '';
    self.popular = root.getAttribute('data-popular') || 'Beliebteste Wahl';
    self.state = { pack: null, flavour: null, shot: 0 };

    self.current = function () {
      for (var i = 0; i < self.products.length; i++) if (self.products[i].handle === MI.product) return self.products[i];
      return self.products[0];
    };
    self.packs = function (p) { return uniq(p.variants.map(function (v) { return v.pack; })); };
    self.flavours = function (p) { return uniq(p.variants.map(function (v) { return v.flavour; })); };
    self.variant = function () {
      var p = self.current(); if (!p) return null;
      for (var i = 0; i < p.variants.length; i++) { var v = p.variants[i]; if (v.pack === self.state.pack && v.flavour === self.state.flavour) return v; }
      return null;
    };
    self.defaults = function () {
      var p = self.current(); if (!p) return;
      var ps = self.packs(p), fs = self.flavours(p);
      if (ps.indexOf(self.state.pack) < 0) self.state.pack = ps.indexOf('3 Packs') >= 0 ? '3 Packs' : ps[ps.length - 1];
      if (fs.indexOf(self.state.flavour) < 0) self.state.flavour = fs.indexOf(self.defaultFlavour) >= 0 ? self.defaultFlavour : fs[0];
    };

    self.render = function () {
      var p = self.current(); if (!p) return;
      self.defaults();
      var s = self.state;

      var single = null;
      p.variants.forEach(function (v) { if (v.flavour === s.flavour && packCount(v.pack) === 1) single = v.price; });
      root.querySelector('[data-mi-packs]').innerHTML = self.packs(p).map(function (label) {
        var v = null; p.variants.forEach(function (x) { if (x.pack === label && x.flavour === s.flavour) v = x; });
        if (!v) return '';
        var n = packCount(label);
        var save = (single && n > 1) ? Math.round((1 - v.price / (single * n)) * 100) : 0;
        return '<button type="button" class="mi-pack' + (n === 3 ? ' mi-pack--badged' : '') + '" data-mi-pick-pack="' + esc(label) + '"' + (label === s.pack ? ' data-on' : '') + '>' +
          (n === 3 ? '<span class="mi-pack__badge">' + esc(self.popular) + '</span>' : '') +
          '<div class="mi-pack__name">' + esc(label) + '</div>' +
          '<div class="mi-pack__price">' + fmt(Math.round(v.price / n)) + '<span class="mi-pack__unit"> / Stk.</span></div>' +
          (save > 0 ? '<div class="mi-pack__save">Spare ' + save + ' %</div>' : '') +
          '</button>';
      }).join('');

      root.querySelector('[data-mi-flavours]').innerHTML = self.flavours(p).map(function (f) {
        return '<button type="button" class="mi-pill" data-mi-pick-flavour="' + esc(f) + '"' + (f === s.flavour ? ' data-on' : '') + '><span class="mi-pill__dot" style="background:' + (FLAVOUR_DOTS[f] || '#6E655E') + '"></span>' + esc(f) + '</button>';
      }).join('');

      var v = self.variant();
      all('[data-mi-cta]', root).forEach(function (b) { b.textContent = self.ctaLabel + (v ? ' · ' + fmt(v.price) : ''); b.disabled = !v; });
      var unit = self.unitPrice(v, p), unitEl = root.querySelector('[data-mi-unitprice]'), unitSep = root.querySelector('[data-mi-unitsep]');
      if (unitEl) { unitEl.textContent = unit ? 'Grundpreis: ' + unit : ''; unitEl.hidden = !unit; }
      if (unitSep) unitSep.hidden = !unit;
      self.renderGallery(v, p);
    };

    /* Grundpreis je 100 g: Shopify-Grundpreis der Variante, sonst Preis / (Gramm pro Pack × Packzahl) */
    self.unitPrice = function (v, p) {
      if (!v) return '';
      if (v.unit_price && v.unit_ref && v.unit_unit) return fmt(v.unit_price) + '/' + v.unit_ref + String(v.unit_unit).toLowerCase();
      var perPack = (p && parseFloat(p.pack_grams)) || 0;
      var grams = perPack * packCount(v.pack);
      if (!grams) return '';
      return fmt(Math.round(v.price / grams * 100)) + '/100g';
    };

    /* Galerie aus den Produktmedien: Bild der gewählten Geschmacks-Variante zuerst,
       dann alle Bilder, die keiner Geschmacks-Variante zugeordnet sind (Varianten-Bilder = Geschmacks-Bilder).
       Ohne Produktmedien bleibt die Fallback-Galerie aus den Section-Settings stehen. */
    self.galleryList = function (v, p) {
      if (!p || !p.media || !p.media.length) return [];
      var byId = {}; p.media.forEach(function (m) { byId[m.id] = m; });
      var flavourIds = {}; p.variants.forEach(function (x) { if (x.media_id) flavourIds[x.media_id] = true; });
      var list = [];
      var mainId = v && v.media_id;
      if (mainId && byId[mainId]) list.push(byId[mainId]);
      p.media.forEach(function (m) { if (!flavourIds[m.id]) list.push(m); });
      if (!list.length) list = p.media.slice();
      return list;
    };
    self.renderGallery = function (v, p) {
      var list = self.galleryList(v, p);
      var stage = root.querySelector('[data-mi-stage]'), thumbs = root.querySelector('[data-mi-thumbs]');
      if (!stage || !thumbs || !list.length) { self.renderShot(); return; }
      var key = list.map(function (m) { return m.id; }).join(',');
      if (key !== self.galleryKey) {
        self.galleryKey = key;
        stage.innerHTML = list.map(function (m, i) {
          return '<div class="mi-gallery__shot" data-mi-shot="' + i + '"' + (i === 0 ? ' data-on' : '') + '><img src="' + esc(m.url) + '" alt="' + esc(m.alt) + '" width="1400" height="1400" loading="' + (i === 0 ? 'eager' : 'lazy') + '"></div>';
        }).join('');
        thumbs.innerHTML = list.map(function (m, i) {
          return '<button type="button" class="mi-thumb" data-mi-pick-shot="' + i + '"' + (i === 0 ? ' data-on' : '') + ' aria-label="Bild ' + (i + 1) + '"><img src="' + esc(m.thumb) + '" alt="" width="300" height="300" loading="lazy"></button>';
        }).join('');
        thumbs.setAttribute('data-count', String(list.length));
        self.state.shot = 0;
      }
      self.renderShot();
    };

    /* Mobil ist die Bühne ein Wisch-Karussell (CSS): Auswahl scrollt zum Bild, Wischen setzt die Auswahl */
    self.stageScrollable = function () { var st = root.querySelector('[data-mi-stage]'); return st && st.scrollWidth > st.clientWidth + 1 ? st : null; };
    self.renderShot = function (fromScroll) {
      var cur = String(self.state.shot);
      all('[data-mi-shot]', root).forEach(function (e) { if (e.getAttribute('data-mi-shot') === cur) e.setAttribute('data-on', ''); else e.removeAttribute('data-on'); });
      all('[data-mi-pick-shot]', root).forEach(function (e) { if (e.getAttribute('data-mi-pick-shot') === cur) e.setAttribute('data-on', ''); else e.removeAttribute('data-on'); });
      var st = self.stageScrollable();
      if (st && !fromScroll) {
        var target = self.state.shot * st.clientWidth;
        if (Math.abs(st.scrollLeft - target) > 2) st.scrollTo({ left: target, behavior: 'smooth' });
      }
      /* Sticky-Bar zeigt immer das aktuelle Hauptbild (Variante, Produkt oder Galerie) */
      var active = root.querySelector('[data-mi-shot][data-on] img'), thumb = root.querySelector('[data-mi-sticky] img');
      if (active && thumb) {
        var src = active.currentSrc || active.getAttribute('src') || '';
        src = src.replace(/([?&])width=\d+/, '$1width=160');
        if (src && thumb.getAttribute('src') !== src) { thumb.setAttribute('src', src); thumb.removeAttribute('srcset'); thumb.alt = active.alt || ''; }
      }
    };

    self.add = function () {
      var v = self.variant(); if (!v) return;
      var err = root.querySelector('[data-mi-error]');
      all('[data-mi-cta]', root).forEach(function (b) { b.disabled = true; });
      if (err) err.hidden = true;
      var hdr = { 'Content-Type': 'application/json', 'Accept': 'application/json' };
      fetch('/cart/clear.js', { method: 'POST', headers: hdr })
        .then(function () { return fetch('/cart/add.js', { method: 'POST', headers: hdr, body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }] }) }); })
        .then(function (r) { if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || j.message || 'Fehler'); }); return r.json(); })
        .then(function () { window.location.href = '/checkout'; })
        .catch(function (e) {
          if (err) { err.textContent = 'Das hat nicht geklappt: ' + e.message + '. Bitte versuch es noch einmal.'; err.hidden = false; }
          all('[data-mi-cta]', root).forEach(function (b) { b.disabled = false; });
        });
    };

    root.addEventListener('click', function (e) {
      var t = e.target.closest('[data-mi-pick-pack], [data-mi-pick-flavour], [data-mi-pick-shot], [data-mi-add], [data-mi-vid]');
      if (!t) return;
      if (t.hasAttribute('data-mi-vid')) {
        var wrap = t.querySelector('.mi-vid__video'), vid = wrap && wrap.querySelector('video');
        if (!vid || t.hasAttribute('data-playing')) return;
        all('[data-mi-vid][data-playing]', root).forEach(function (o) { var ov = o.querySelector('video'); if (ov) ov.pause(); o.removeAttribute('data-playing'); var ow = o.querySelector('.mi-vid__video'); if (ow) ow.hidden = true; });
        wrap.hidden = false; t.setAttribute('data-playing', ''); vid.play();
        return;
      }
      if (t.hasAttribute('data-mi-pick-pack')) { self.state.pack = t.getAttribute('data-mi-pick-pack'); self.render(); }
      else if (t.hasAttribute('data-mi-pick-flavour')) { self.state.flavour = t.getAttribute('data-mi-pick-flavour'); self.render(); }
      else if (t.hasAttribute('data-mi-pick-shot')) { self.state.shot = parseInt(t.getAttribute('data-mi-pick-shot'), 10); self.renderShot(); }
      else if (t.hasAttribute('data-mi-add')) { self.add(); }
    });

    window.addEventListener('mi:product', self.render);

    var stageEl = root.querySelector('[data-mi-stage]');
    if (stageEl) stageEl.addEventListener('scroll', function () {
      if (!self.stageScrollable()) return;
      var idx = Math.round(stageEl.scrollLeft / stageEl.clientWidth);
      if (idx !== self.state.shot && idx >= 0) { self.state.shot = idx; self.renderShot(true); }
    }, { passive: true });

    /* Sticky-Bar mobil, wenn der Haupt-CTA aus dem Bild ist */
    var sticky = root.querySelector('[data-mi-sticky]'), cta = root.querySelector('.mi-buybox [data-mi-cta]');
    self.onScroll = function () { if (sticky && cta) sticky.setAttribute('data-shown', cta.getBoundingClientRect().bottom < 0 ? '1' : '0'); };
    window.addEventListener('scroll', self.onScroll, { passive: true });
    window.addEventListener('resize', self.onScroll);

    self.render();
    self.renderShot();
    self.onScroll();
    return self;
  }

  /* ---------- Header ---------- */
  function Header(root) {
    if (root.__mi) return root.__mi;
    var self = root.__mi = { root: root };
    var menu = root.querySelector('[data-mi-menu]'), btn = root.querySelector('[data-mi-menu-toggle]');
    self.close = function () { if (menu) { menu.hidden = true; btn.setAttribute('aria-expanded', 'false'); } };
    self.toggle = function () { var open = !menu.hidden; menu.hidden = open; btn.setAttribute('aria-expanded', String(!open)); };
    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-mi-menu-toggle]')) { self.toggle(); return; }
      if (e.target.closest('[data-mi-pick-product]')) self.close();
    });
    document.addEventListener('click', function (e) { if (!e.target.closest('.mi-headbar')) self.close(); });
    var lastY = 0;
    self.onScroll = function () {
      var y = window.scrollY || document.documentElement.scrollTop || 0;
      if (y > lastY && y > 140) root.setAttribute('data-hidden', ''); else root.removeAttribute('data-hidden');
      lastY = y;
    };
    window.addEventListener('scroll', self.onScroll, { passive: true });
    return self;
  }

  /* ---------- Bewertungen: Seitenwechsel ---------- */
  function Reviews(root) {
    if (root.__mi) return root.__mi;
    var self = root.__mi = { root: root, page: 1 };
    var list = root.querySelector('[data-mi-review-list]'), pager = root.querySelector('[data-mi-pager]');
    var items = list ? all('.mi-review', list) : [];
    var per = parseInt(root.getAttribute('data-per-page'), 10) || 8;
    var pages = Math.max(1, Math.ceil(items.length / per));
    var arrow = function (dir) { return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="' + (dir < 0 ? 'M15 18l-6-6 6-6' : 'M9 18l6-6-6-6') + '"/></svg>'; };
    self.render = function () {
      items.forEach(function (el, i) { el.hidden = Math.floor(i / per) + 1 !== self.page; });
      if (!pager) return;
      if (pages < 2) { pager.hidden = true; return; }
      var html = '<button type="button" class="mi-pager__arrow" data-mi-page="' + (self.page - 1) + '"' + (self.page === 1 ? ' disabled' : '') + ' aria-label="Vorherige Seite">' + arrow(-1) + '</button>';
      for (var p = 1; p <= pages; p++) html += '<button type="button" data-mi-page="' + p + '"' + (p === self.page ? ' aria-current="page"' : '') + ' aria-label="Seite ' + p + '">' + p + '</button>';
      html += '<button type="button" class="mi-pager__arrow" data-mi-page="' + (self.page + 1) + '"' + (self.page === pages ? ' disabled' : '') + ' aria-label="Nächste Seite">' + arrow(1) + '</button>';
      pager.innerHTML = html; pager.hidden = false;
    };
    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-mi-page]'); if (!b || b.disabled) return;
      var p = parseInt(b.getAttribute('data-mi-page'), 10);
      if (p < 1 || p > pages || p === self.page) return;
      self.page = p; self.render();
      if (list) window.scrollTo({ top: list.getBoundingClientRect().top + window.scrollY - 110, behavior: 'smooth' });
    });
    self.render();
    return self;
  }

  /* ---------- global: Produktwahl, Akkordeons ---------- */
  document.addEventListener('click', function (e) {
    var pick = e.target.closest('[data-mi-pick-product]');
    if (pick) {
      MI.set(pick.getAttribute('data-mi-pick-product'));
      if (pick.tagName === 'A') { var bb = document.getElementById('buybox'); if (bb) { e.preventDefault(); bb.scrollIntoView({ behavior: 'smooth', block: 'start' }); } }
      return;
    }
    var q = e.target.closest('[data-mi-acc-toggle]');
    if (q) {
      var open = q.getAttribute('aria-expanded') === 'true';
      var group = q.closest('[data-mi-accordion], [data-mi-faq]');
      if (group) all('[data-mi-acc-toggle]', group).forEach(function (x) { x.setAttribute('aria-expanded', 'false'); x.nextElementSibling.hidden = true; x.querySelector('[aria-hidden]').textContent = '+'; });
      if (!open) { q.setAttribute('aria-expanded', 'true'); q.nextElementSibling.hidden = false; q.querySelector('[aria-hidden]').textContent = '−'; }
    }
  });

  function initAll(ctx) {
    all('[data-mi-hero]', ctx).forEach(Hero);
    all('[data-mi-header]', ctx).forEach(Header);
    all('[data-mi-reviews]', ctx).forEach(Reviews);
    MI.initProduct();
  }

  /* Theme-Editor: Section neu geladen oder ausgewählt */
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:block:select', function () { MI.apply(); });

  initAll(document);
})();
